export default __webpack_public_path__ + "img/0a7f69002f1c5078293767473dcce8db.gif";